import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Option, Response} from '../../model/GeneralModels';
import {GeneralService} from '../../services/general.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-company-field',
  template: `
    <app-select-field
      [Group]="Group"
      [fieldLabel]="'بیمه'"
      [options]="company$"
      [fieldName]="'companyName'"
      [Icon]="true"
      [viewList]="viewList"
      (OnChange)="selectionChanged()"
    ></app-select-field>

  `,
  styleUrls: []
})
export class CompanyFieldComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() required: boolean;
  @Input() productName: string;
  @Input() viewList: any = {};
  @Output() OnCompanyUpdateList = new EventEmitter<Option[]>();
  @Output() OnSelectionChange = new EventEmitter<Option>();
  company$: Option[] = [];

  constructor(private service: GeneralService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Group && !this.Group.controls.companyName) {
      this.Group.addControl('companyName', new FormControl(''));
    }
    if (this.required) {
      this.Group.controls.companyName.setValidators([Validators.required]);
    } else {
      this.Group.controls.companyName.setValidators([]);
    }
    if (this.productName) {
      this.getCompanyList();
    }
  }

  getCompanyList() {
    this.service.getClientCompanyList(this.productName).subscribe((response: Response) => {
      if (response.success) {
        response.data.forEach(company => {
          this.company$[this.company$.length] = new Option(company.label, company.value);
        });
        this.OnCompanyUpdateList.emit(this.company$);
      }
    });
  }

  selectionChanged() {
    const selected = this.company$.find(company => {
      return company.value === this.Group.controls.companyName.value;
    });
    this.OnSelectionChange.emit(selected);
  }
}
